import React from "react";
import Webcam from "react-webcam";
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera'

import { imgDimensions, videoConstraints } from "../Camera.options";
import { ImageWrapper } from "./ImageSelfie.styles";
import { ImageSelfieActions, ImageSelfieMessage, ImageSelfieViewer } from "./ImageSelfie.elements";
import { CameraIsNotActive } from "../Camera.elements";

function ImageSelfie({ onImageUpload, instructions = '' }) {
  const webcamRef = React.useRef();
  const [image, setImage] = React.useState('');
  const [error, setError] = React.useState(false);

  const handleImageCapture = () => {
    const imageSrc = webcamRef.current?.getScreenshot?.()
    setImage(imageSrc)
    onImageUpload(imageSrc)
  }

  const selfieActions = [{
    icon: PhotoCameraIcon,
    onClick: handleImageCapture
  }]

  if(error) {
    return <CameraIsNotActive refreshCameraSettings={() => setError(false)}/>
  }

  return (
    <>
      {instructions && (
        <ImageSelfieMessage 
          message={instructions} 
          width={imgDimensions.width}
        />
      )}
      <ImageWrapper 
        width={imgDimensions.width}
        height={imgDimensions.height}
      >
        {image && (
          <ImageSelfieViewer 
            image={image}
            imgDimensions={imgDimensions} 
          />
        )}
        {!image && (
          <Webcam
            ref={webcamRef}
            audio={false}
            height={imgDimensions.height}
            width={imgDimensions.width}
            style={{objectFit: 'cover'}}
            minScreenshotWidth={imgDimensions.width * 4}
            minScreenshotHeight={imgDimensions.height * 4}
            screenshotQuality={1}
            screenshotFormat={"image/jpeg"}
            videoConstraints={videoConstraints}
            onUserMediaError={() => setError(true)}
          />
        )}
        <ImageSelfieActions actions={selfieActions} loading={!!image} />
      </ImageWrapper>
    </>
  );
}



export default ImageSelfie;
